import { useQuery } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';
import type { StandardTermSearchParams } from '../types/terminology';

/**
 * GET /api/eraf/terminology/standard-terms (paged search)
 * queryKey: ['terminology', 'standard-terms', 'list', params]
 */
export function useStandardTerms(params: StandardTermSearchParams = {}) {
  return useQuery({
    queryKey: ['terminology', 'standard-terms', 'list', params],
    queryFn: () => terminologyApi.listStandardTerms(params),
    staleTime: 15_000,
  });
}
